import { render, staticRenderFns } from "./addTrip.vue?vue&type=template&id=269d6854&"
import script from "./addTrip.vue?vue&type=script&lang=js&"
export * from "./addTrip.vue?vue&type=script&lang=js&"
import style0 from "./addTrip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "addTrip.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VSwitch,
  VTextField,
})
